/* eslint-disable no-console */
import Vue from 'vue'

export default {
  state: {
    infoSelf: []
  },
  mutations: {
    SET_PM(state, payload){
      state.infoSelf = payload
    }
  },
  actions: {
    LOAD_PM({commit}){
      Vue.$db.collection('progress')
      .get()
      .then(querySnapshot => {
        let infoSelf = [] 
        querySnapshot.forEach(s => {
          const data = s.data()
          infoSelf.push(data)
        })
        commit('SET_PM', infoSelf)
      })
      .catch(error => {console.log(error)})
    }
  },
  getters:{
    getPM: (state) => state.infoSelf
  }
}
/* eslint-enable no-console */